import React from 'react'
import { CCard } from '@coreui/react-pro'
import './ContactUs.scss'
const ContactUs = () => {
  const openDraftEmail = () => {
    window.open('https://portal.claimocity.com/help', '_blank')
  }
  return (
    <>
      <br />
      <br />
      <CCard className="contactus-card">
        <div className="contactus-CardHeader">
          <p>Do you need help?</p>
        </div>
        <p className="contactus-subHeader">
          You can find answers to the most commonly asked questions in our Help Center.
        </p>
        <button className="contact-us-btn" onClick={openDraftEmail}>
          Help Center
        </button>
      </CCard>
    </>
  )
}
export default ContactUs
